import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { indexOf, each } from 'lodash';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';

import requiredSetupMappings from '../../../../components/required-setup-mappings';
import requiredSync from '../../../../components/required-sync';
import orgAwearness from '../../../../components/organization-awearness';
import getMenus from '../../components/nav/menus';

import DecisionPage from '../DecisionPage/DecisionPage';
import ExperiencePage from '../ExperiencePage/ExperiencePage';
import DashboardPage from '../DashboardPage/DashboardPage';
import ExclusionPage from '../ExclusionPage/ExclusionPage';
import ProgressPage from '../ProgressPage/ProgressPage';
// import EnsureTeamSetup from '../../../Dashboard/pages/DashboardPage/EnsureTeamSetup';

import {
  getUser, getIsSuperAdmin, getIsAdmin, getIsPIUser,
  getUserCurrentOrganization,
} from '../../../Auth/AuthReducer';

class FeedbackPage extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      location: { pathname },
      user, userCurrentOrganization, canSeeAllPages,
    } = this.props;
    const menus = getMenus(user, userCurrentOrganization, canSeeAllPages);
    let comps = null;
    if (menus && menus.length) {
      const components = {
        buyer_decisions: DecisionPage,
        customer_experience: ExperiencePage,
        dashboard: DashboardPage,
        progress_dashboard: ProgressPage,
      };
  
      const routers = [];
      const validSlugs = [];
      each(menus, (menu) => {
        validSlugs.push(menu.slug);
        routers.push(<Route key={menu.key} exact path={menu.slug} component={components[menu.key]} />);
      });
  
      if (indexOf(validSlugs, pathname) < 0) {
        if (menus[0]) {
          return (<Redirect key="redirect" to={menus[0].slug} />);
        }
        return (<Redirect key="redirect" to="/" />);
      }
      comps = (<Switch>{routers}</Switch>);
    } else {
      comps = (<div className="container"><div className="alert alert-warning">No modules found</div></div>);
    }
    return (
      <div id="feedback-page">
        <Helmet title="Feedback" />
        <div className="container">
          <div className="clearfix">
            <h1 className="page-header">
              Feedback
            </h1>
          </div>
        </div>
        {comps}
      </div>
    );
  }

}

// Retrieve data from store as props
function mapStateToProps(state) {
  const isAdmin = getIsAdmin(state);
  const isSuperAdmin = getIsSuperAdmin(state);
  const isPIUser = getIsPIUser(state);
  const userCurrentOrganization = getUserCurrentOrganization(state);
  const user = getUser(state);
  let canSeeAllPages = false;
  if (isAdmin || isSuperAdmin) {
    canSeeAllPages = true;
  } else if (isPIUser && user && userCurrentOrganization && indexOf(user.organization__ids, userCurrentOrganization._id) >= 0) {
    canSeeAllPages = true;
  }

  return {
    user,
    canSeeAllPages,
    userCurrentOrganization,
  };
}

FeedbackPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  canSeeAllPages: PropTypes.bool,
  user: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    organization_role: PropTypes.string.isRequired,
  }).isRequired,
  userCurrentOrganization: PropTypes.shape({
    role_access_rules: PropTypes.shape({}).isRequired,
    features: PropTypes.shape({}).isRequired,
  }).isRequired,
};
FeedbackPage.defaultProps = {
  canSeeAllPages: false,
};

FeedbackPage.contextTypes = {
  router: PropTypes.shape({}),
};
// export default connect(mapStateToProps)(orgAwearness(requiredSync(requiredSetupMappings(withRouter(EnsureTeamSetup(FeedbackPage)), ['stage', 'dealType']))));
export default connect(mapStateToProps)(orgAwearness(requiredSync(requiredSetupMappings(withRouter(FeedbackPage), ['stage', 'dealType']))));
